import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { createNormalizedMap, handleFetchError, pushApps } from 'action-utils';
import { setSearchInput } from 'actions/gallery';
import { searchPreviewQuery } from '../../queries';

const STATE_PROP = 'searchPreview';

export default new AsyncActionHandler({
  name: 'search_preview',
  stateProp: STATE_PROP,
  defaultState: {
    [STATE_PROP]: {},
    searchPages: {},
    apps: {}
  },
  handler(text) {
    return async (dispatch) => {
      dispatch(setSearchInput({ text, userSetInput: true }));

      if (!text) {
        return;
      }

      try {
        const {
          data: { appSearchResults, clockSearchResults, tileSearchResults } = {}
        } = await apollo.query({
          query: searchPreviewQuery,
          variables: {
            text
          },
          fetchPolicy: 'no-cache'
        });

        return {
          text,
          appSearchResults,
          clockSearchResults,
          tileSearchResults
        };
      } catch (error) {
        return handleFetchError(error);
      }
    };
  },
  reduce(
    state,
    { text, appSearchResults, clockSearchResults, tileSearchResults }
  ) {
    if (!appSearchResults || !clockSearchResults || !tileSearchResults) {
      return state;
    }

    const allEntries = [
      ...appSearchResults.apps,
      ...clockSearchResults.apps,
      ...tileSearchResults.apps
    ];
    const entries = pushApps([], allEntries);

    return {
      [this.stateProp]: {
        [text]: {
          entries
        }
      },
      apps: {
        ...state.apps,
        ...createNormalizedMap(allEntries, state.apps)
      }
    };
  }
});
